module.exports = __webpack_public_path__ + "img/payment-icon.d6a5b6ba.png";